var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRakutencolorinline = function SvgRakutencolorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.747 19.167L1.25 17.105h17.5L3.747 19.167zm2.841-3.608v-4.572h2.01l3.48 4.572h3.564l-4.211-5.516a5.081 5.081 0 001.9-2.53 5 5 0 00.022-3.147 5.078 5.078 0 00-1.868-2.554A5.208 5.208 0 008.447.833h-4.7V15.56h2.841zm0-11.93h1.86a2.352 2.352 0 011.687.642 2.254 2.254 0 010 3.28 2.324 2.324 0 01-1.688.643H6.59V3.629z",
    fill: "#BF0000"
  })));
};

export default SvgRakutencolorinline;